import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ContentCutIcon from '@mui/icons-material/ContentCut';

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '12px 24px',
  fontWeight: 500,
  fontSize: '0.95rem',
  letterSpacing: '0.01em',
  textTransform: 'none',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  boxShadow: '0 2px 8px rgba(99, 102, 241, 0.15)',
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  color: '#FFFFFF',
  transition: 'all 0.2s ease',
  '& .MuiSvgIcon-root': {
    fontSize: '1.2rem',
    transition: 'transform 0.2s ease',
  },
  '&:hover': {
    background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.25)',
    '& .MuiSvgIcon-root': {
      transform: 'rotate(-5deg)',
    },
  },
  '&:active': {
    background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
    boxShadow: '0 2px 4px rgba(99, 102, 241, 0.2)',
  },
  '&.Mui-disabled': {
    background: theme.palette.mode === 'dark'
      ? 'rgba(99, 102, 241, 0.12)'
      : 'rgba(99, 102, 241, 0.12)',
    color: theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.3)'
      : 'rgba(0, 0, 0, 0.3)',
  }
}));

export default ActionButton;
